import * as actionTypes from "../../../../actions/actionTypes";
import {updateObject} from "../../../../../utils/utils";

const initialState = {
    loading : true,
    error: null,
    listeCours: []
};

const adminCoursFetchListeCoursStart = (state,action) => {
    return updateObject(state,{
        ...state,
        loading : true,
        error: null,
        listeCours: []
    });
};

const adminCoursFetchListeCoursSuccess = (state,action) => {
    return updateObject(state,{
        ...state,
        loading : false,
        error: null,
        listeCours: action.payload.listeCours
    });
};

const adminCoursFetchListeCoursFail = (state,action) => {
    return updateObject(state,{
        ...state,
        loading : false,
        error: action.payload.error,
        listeCours: []
    });
};

function reducer(state = initialState,action) {

    switch (action.type) {
        case actionTypes.ADMIN_COURS_FETCH_LISTE_COURS_START : return adminCoursFetchListeCoursStart(state,action);
        case actionTypes.ADMIN_COURS_FETCH_LISTE_COURS_SUCCESS : return adminCoursFetchListeCoursSuccess(state,action);
        case actionTypes.ADMIN_COURS_FETCH_LISTE_COURS_FAIL : return adminCoursFetchListeCoursFail(state,action);

        default : return state;
    }

}

export default reducer;